var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20.0588,
    width: 12.6667,
    height: 42.3529,
    rx: 0.5,
    fill: "url(#paint0_linear_3125_4048)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.3333,
    y: 7.35303,
    width: 12.6667,
    height: 42.3529,
    rx: 0.5,
    fill: "url(#paint1_linear_3125_4048)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2222,
    y: 15.8235,
    width: 12.6667,
    height: 21.1765,
    rx: 0.5,
    fill: "url(#paint2_linear_3125_4048)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1111,
    y: 37,
    width: 12.6667,
    height: 21.1765,
    rx: 0.5,
    fill: "url(#paint3_linear_3125_4048)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 9.4707L6.33325 73.0001",
    stroke: "url(#paint4_linear_3125_4048)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6667 1V58.1765",
    stroke: "url(#paint5_linear_3125_4048)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5557 9.4707V43.3531",
    stroke: "url(#paint6_linear_3125_4048)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4443 30.647V64.5293",
    stroke: "url(#paint7_linear_3125_4048)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3125_4048",
    x1: 0,
    y1: 41.2353,
    x2: 12.6667,
    y2: 41.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3125_4048",
    x1: 63.3333,
    y1: 28.5295,
    x2: 75.9999,
    y2: 28.5295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3125_4048",
    x1: 42.2222,
    y1: 26.4117,
    x2: 54.8888,
    y2: 26.4117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3125_4048",
    x1: 21.1111,
    y1: 47.5882,
    x2: 33.7778,
    y2: 47.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3125_4048",
    x1: 5.83325,
    y1: 9.4707,
    x2: 5.83321,
    y2: 73.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3125_4048",
    x1: 69.1667,
    y1: 1,
    x2: 69.1667,
    y2: 58.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3125_4048",
    x1: 48.0557,
    y1: 9.4707,
    x2: 48.0557,
    y2: 43.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3125_4048",
    x1: 26.9443,
    y1: 30.647,
    x2: 26.9443,
    y2: 64.5293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.42eeab17b53d886ca76de6cf69d111d5.svg";
export { ForwardRef as ReactComponent };